import React from 'react';

export function Reporting() {
  return <div>Reporting.Container</div>;
}
